<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div i18n class="detail-label flex-grow-1">CRA Minimum Calculation Age</div>
    <div class="d-flex flex-column gap-1 align-items-end">
      <div i18n class="detail-value">{{ minimumDetails.formattedDateOfBirth }}</div>
      <div i18n class="detail-sub-value">
        {{ minimumDetails.isSpouse ? 'Spouse' : 'Member' }}, Age {{ minimumDetails.formattedDateOfBirth | age }}
      </div>
    </div>
  </div>
</div>
